import FaqPage from '@/components/feature/FaqPage';

export default function SmQ3Page() {
  return (
    <FaqPage
      category="Subscription Management"
      categoryPath="/"
      icon="ri-question-line"
      title="What if I never received the product or service?"
      intro="Get help when you haven't received your purchased product or service. We'll guide you through the steps to resolve delivery issues."
      sections={[
        {
          heading: 'I paid but never received access — what should I do?',
          content: [
            'First, check your email inbox (including spam/junk folders) for a confirmation or access email. Sometimes delivery can be delayed by a few minutes.',
            'If you still cannot find it after 30 minutes, log in to your account and check the "My Purchases" or "My Subscriptions" section to see if your order is listed.',
          ],
        },
        {
          heading: 'My order shows as complete but I still have no access',
          content: [
            'If your order is marked as complete but you cannot access the product or service, please contact our support team immediately with your order ID and the email address used at checkout.',
            'Our team will investigate and restore your access or issue a resolution within 24–48 hours.',
          ],
        },
        {
          heading: 'What if the product was a physical item?',
          content: [
            'For physical products, please allow the standard delivery window stated at the time of purchase. If your item has not arrived within that window, contact our support team with your order number.',
            'We will liaise with the delivery provider and provide you with a tracking update or arrange a replacement/refund as appropriate.',
          ],
        },
        {
          heading: 'Can I get a refund if I never received the product?',
          content: [
            'Yes. If we are unable to deliver the product or restore your access, you are entitled to a full refund. Please submit a dispute resolution request or contact our support team to initiate the refund process.',
          ],
        },
      ]}
    />
  );
}
